export const BASE_URL = "https://satisfying-family-56007fa368.strapiapp.com";